/* 🤖 this file was generated by svg-to-ts */
export const matIconAreaChart: {
  name: 'area-chart';
  data: string;
} = {
  name: 'area-chart',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m17 7-5-4-5 7-4-3v13h18V7h-4zm2 9.95-7-5.45L8 17l-3-2.4V11l2.44 1.83 4.96-6.95L16.3 9H19v7.95z"/></svg>`
};
